var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Card", {
        attrs: { title: "Customer Lifetime Value" },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function() {
              return [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "pb-6 flex justify-between items-start" },
                    [
                      _c("div", { staticClass: "flex items-center" }, [
                        _c(
                          "div",
                          { staticClass: "mr-2" },
                          [
                            _c("date-range-picker", {
                              ref: "picker",
                              attrs: {
                                timePicker: false,
                                showDropdowns: false,
                                "max-date": _vm.maxDate,
                                opens: "right",
                                "auto-apply": true
                              },
                              on: { update: _vm.onChangeDate },
                              scopedSlots: _vm._u([
                                {
                                  key: "input",
                                  fn: function(picker) {
                                    return [
                                      _vm._v(
                                        "\n                  From: " +
                                          _vm._s(_vm.moment(picker.startDate)) +
                                          " - To: " +
                                          _vm._s(_vm.moment(picker.endDate)) +
                                          "\n                "
                                      )
                                    ]
                                  }
                                }
                              ]),
                              model: {
                                value: _vm.dateRange,
                                callback: function($$v) {
                                  _vm.dateRange = $$v
                                },
                                expression: "dateRange"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {},
                          [
                            _c(
                              "download-excel",
                              {
                                staticClass: "px-2 md:w-50",
                                attrs: {
                                  data: _vm.data,
                                  fields: _vm.excel_fields,
                                  meta: _vm.excel_meta,
                                  worksheet: "My Worksheet",
                                  name: "ltv.xls"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex items-end p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100",
                                    class: "bg-indigo-500 text-gray-100"
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "m-auto text-xs font-medium"
                                      },
                                      [
                                        _vm._v(
                                          "\n                    Download Excel\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pb-6 flex",
                          staticStyle: { gap: "16px" }
                        },
                        [
                          _c("card-stats", {
                            attrs: {
                              statSubtitle: "Lifetime Avg In Days",
                              statTitle: _vm.lifetimeAvgInDays,
                              "stat-icon-name": "fa fa-users"
                            }
                          }),
                          _vm._v(" "),
                          _c("card-stats", {
                            attrs: {
                              statSubtitle: "Lifetime Revenue Avg",
                              statTitle: "$" + _vm.lifetimeRevenueAvg
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "data-tables-server",
                  {
                    ref: "tableTransaction",
                    attrs: {
                      data: _vm.data,
                      total: _vm.total,
                      "pagination-props": {
                        background: true,
                        pageSizes: [_vm.displayingItem]
                      }
                    },
                    on: { "query-change": _vm.onChangeTable }
                  },
                  _vm._l(_vm.tableColumn, function(title) {
                    return _c("el-table-column", {
                      key: title.prop,
                      attrs: {
                        prop: title.prop,
                        label: title.label,
                        sortable: "custom"
                      }
                    })
                  }),
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14309e45", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14309e45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CLTV.vue
// module id = null
// module chunks = 